import api from ".";
import { fetchAuthSession } from 'aws-amplify/auth';

const fetchAccessToken = async () => {
  const session = await fetchAuthSession();
  return session.tokens.accessToken.toString();
}

const makePostRequest = async (body, path) => {
  const accessToken = await fetchAccessToken();

  try {
    const result = await api(path, {
      method: "POST",
      body: body,
      headers: {
          'Authorization': `Bearer ${accessToken}`
      },
    });
    return result;
  } catch (error) {
    console.error("Error posting data:", error.message);
    throw error;
  }
};

export { makePostRequest };
